module.exports = __webpack_public_path__ + "static/media/vur.b8a92837.png";